import { createContext } from "react";

export const LoggedInContext = createContext({
  isLoggedIn: false,
  login: () => {},
  logout: () => {},
});
